import React from 'react';
import {NavLink} from "react-router-dom";
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DescriptionIcon from '@material-ui/icons/Description';
import CommuteIcon from '@material-ui/icons/Commute';
import ArchiveIcon from '@material-ui/icons/Archive';
import MapIcon from '@material-ui/icons/Map';
import ExploreIcon from '@material-ui/icons/Explore';
import AssignmentIcon from '@material-ui/icons/Assignment';

export const mainListItems = (
  <div>
    <NavLink exact to="/" style={{ textDecoration: 'none' }} className="nav-link-item">
      <ListItem button>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Tableau de bord" />
      </ListItem>
    </NavLink>
    <NavLink to="/audits" style={{ textDecoration: 'none' }} className="nav-link-item">
      <ListItem button>
          <ListItemIcon>
              <CommuteIcon />
          </ListItemIcon>
          <ListItemText primary="Audits" />
      </ListItem>
    </NavLink>
    <NavLink to="/archives" style={{ textDecoration: 'none' }} className="nav-link-item">
      <ListItem button>
          <ListItemIcon>
              <ArchiveIcon />
          </ListItemIcon>
          <ListItemText primary="Archives" />
      </ListItem>
    </NavLink>
    <NavLink to="/reports" style={{ textDecoration: 'none' }} className="nav-link-item">
      <ListItem button>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Rapports en cours" />
      </ListItem>
    </NavLink>
    <NavLink to="/map" style={{ textDecoration: 'none' }} className="nav-link-item">
      <ListItem button>
        <ListItemIcon>
          <MapIcon />
        </ListItemIcon>
        <ListItemText primary="Carte" />
      </ListItem>
    </NavLink>
      <NavLink to="/journey" style={{ textDecoration: 'none' }} className="nav-link-item">
          <ListItem button>
              <ListItemIcon>
                  <ExploreIcon />
              </ListItemIcon>
              <ListItemText primary="Trajets" />
          </ListItem>
      </NavLink>
    <NavLink to="/invoices" style={{ textDecoration: 'none' }} className="nav-link-item">
      <ListItem button>
        <ListItemIcon>
          <DescriptionIcon />
        </ListItemIcon>
        <ListItemText primary="Factures" />
      </ListItem>
    </NavLink>
  </div>
);

export const secondaryListItems = (
  <div>
    <ListSubheader inset>Saved reports</ListSubheader>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Current month" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Last quarter" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Year-end sale" />
    </ListItem>
  </div>
);



// WEBPACK FOOTER //
// ./src/component/listItems.js